// extracted by mini-css-extract-plugin
export default {"menuLabel":"menuLabel-A5h02","children":"children-Ut_1c","disabled":"disabled-Nf2xc"};